import { useState } from "react";

const faqData = [
  {
    question: "How do I check my NEET UG cut-off?",
    answer: (
      <p>
        You can assess cut-offs by year, round, course, institute, category, and quota using the NEET UG data tools. Historical trends help plan your choices wisely.
      </p>
    ),
  },
  {
    question: "How can I view available seats during counselling?",
    answer: (
      <p>
        The real-time seat matrix shows seat availability for every round, institute, category, and quota so you can strategize efficiently.
      </p>
    ),
  },
  {
    question: "Where can I find details about fees, stipend, and bond conditions?",
    answer: (
      <p>
        Updated information on course fees, stipends, bond rules, and hospital bed strength is available for all quotas and courses.
      </p>
    ),
  },
  {
    question: "How do I track past allotments?",
    answer: (
      <p>
        Allotment data for multiple years, across states, rounds, and quotas, is structured and searchable to help you make informed decisions.
      </p>
    ),
  },
  {
    question: "What is Allotment Mapping?",
    answer: (
      <p>
        Allotment Mapping lets you see how candidates near your rank moved across rounds and states, helping you identify better opportunities.
      </p>
    ),
  },
];

const FAQ = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  return (
    <section className="w-full max-w-7xl mx-auto mt-14 mb-16 sm:mb-0">
      <h2 className="sm:text-3xl text-2xl font-bold text-center capitalize" style={{ color: "#140342", fontSize: "28.125px" }}>
        Frequently asked <span className="text-[#ff9245]">questions</span>
      </h2>
      <div className="mt-8 space-y-4 ml-6 mr-6">
        {faqData.map((faq, index) => (
          <div key={index} className={`p-4 border rounded-lg shadow-md ${activeFAQ === index ? "bg-gray-50" : ""}`} onClick={() => toggleFAQ(index)}>
            <div className="flex justify-between items-center cursor-pointer">
              <h3 className="text-lg font-semibold" style={{ color: "#140342", fontSize: "16.875px" }}>{faq.question}</h3>
              <span>{activeFAQ === index ? "-" : "+"}</span>
            </div>
            <div className={`mt-2 text-gray-600 text-left text-lg ${activeFAQ === index ? "block" : "hidden"}`}>
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
